<select clrSelect name="options" [(ngModel)]="options" (blur)="show()" style="min-height:min-content;">
    <option value="None" [selected]>None</option>
    <option value="Active">Active</option>
    <option value="Archived">Archived</option>
    <option value="Draft">Draft</option>
  </select>